'use es6';

import keyMirror from 'react-utils/keyMirror';
import { loginWithSsoWithPopup } from './ssoLogin';
import { loginWithGoogleAndRedirect } from './googleLogin';
import LoginDao from '../data/LoginDao';
import validateRecomendedResponse from '../utils/validateRecomendedResponse';
import { doesSupportPopup } from '../utils/browserSupport';
const loginDao = new LoginDao();
export const LoginRequirementActionTypes = keyMirror({
  FETCH_LOGIN_REQUIREMENT_BEGIN: null,
  FETCH_LOGIN_REQUIREMENT_SUCCESS: null,
  FETCH_LOGIN_REQUIREMENT_FAILURE: null
});
export const fetchLoginRequirement = (data, history, queryData, handleError) => dispatch => {
  dispatch({
    type: LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_BEGIN
  });
  const fetchRequirements = queryData.loginPortalId ? loginDao.getLoginRequirementWithPortal : loginDao.getLoginRequirement;
  fetchRequirements(data, queryData).then(response => {
    dispatch({
      type: LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_SUCCESS,
      payload: validateRecomendedResponse(response, data, queryData)
    });
    const loginRequirement = response.loginRequirement;

    if (loginRequirement && loginRequirement.loginType === 'SSO' && !loginRequirement.hardRequirement && doesSupportPopup()) {
      loginWithSsoWithPopup({
        email: data.email,
        loginPortalId: loginRequirement.portalId,
        loginRedirectUrl: queryData.loginRedirectUrl,
        history
      })(dispatch);
      history.push(`/beta/select`);
    } else if (loginRequirement && loginRequirement.loginType === 'GOOGLE' && loginRequirement.hardRequirement) {
      const credentials = {
        loginPortalId: loginRequirement.portalId,
        loginRedirectUrl: queryData.loginRedirectUrl
      };
      loginWithGoogleAndRedirect(credentials, handleError, history);
    } else {
      history.push(`/beta/select`);
    }
  }).catch(error => {
    dispatch({
      type: LoginRequirementActionTypes.FETCH_LOGIN_REQUIREMENT_FAILURE,
      payload: error
    });
  });
};